if settings.include_fonts
    each decl in declarations
        if decl.type == 'font'
            | #include "!{decl.data.value}.h"
            |
    |
    |
if settings.include_images
    each decl in declarations
        if decl.type == 'bitmap'
            | static const unsigned char PROGMEM !{decl.data.name}[] = {!{decl.data.value}};
            |
            |
        if decl.type == 'bitmap565'
            | static const uint16_t PROGMEM !{decl.data.name}[] = {!{decl.data.value}};
            |
            |
if settings.declare_vars
    each decl in declarations
        if decl.type == 'var'
            if decl.data.type === 0
                | const char* !{decl.data.name} = "!{decl.data.value}";
                |
            else
                | int !{decl.data.name} = !{decl.data.value};
                |
    |
    |
each layer in layers
    if layer.type == 'polygon'
        - var pts = layer.points
        |
        | void !{layer.functionName}(void) {
        |
        - for (var pi = 0; pi < pts.length; pi++)
            - var npi = (pi + 1) % pts.length
            |     gfx->drawLine(!{pts[pi][0]}, !{pts[pi][1]}, !{pts[npi][0]}, !{pts[npi][1]}, !{packColor(layer.color)});
            |
        | }
        |
if settings.wrap
    | void draw!{screenTitle}(void) {
    |
- var textColor = defaultColor;
- var textSize = '1'
- var textWrap = true
- var pad = settings.wrap ? '    ' : ''
- var font = 'adafruit'
- var stringLayersNumber = 0
if settings.clear_screen
    | !{pad}gfx->!{clear_screen_method};
    |
|
|
each layer in layers 
    if settings.comments
        | !{pad}// !{layer.name}
        |
    case layer.type
        when 'dot'
            | @!{layer.uid};!{pad}gfx->drawPixel(!{layer.x}, !{layer.y}, !{layer.color});
        when 'line'
            | @!{layer.uid};!{pad}gfx->drawLine(!{layer.x1}, !{layer.y1}, !{layer.x2}, !{layer.y2}, !{layer.color});
        when 'rect'
            - var func = (layer.fill ? 'fill' : 'draw') + (layer.radius? 'Round' : '') + 'Rect'
            | @!{layer.uid};!{pad}gfx->!{func}(!{layer.x}, !{layer.y}, !{layer.w}, !{layer.h}!{layer.radius? `, ${layer.radius}`: ''}, !{layer.color});
        when 'circle'
            - var func = layer.fill ? 'fillCircle' : 'drawCircle'
            | @!{layer.uid};!{pad}gfx->!{func}(!{layer.x + layer.radius}, !{layer.y + layer.radius}, !{layer.radius}, !{layer.color});
        when 'ellipse'
            - var func = layer.fill ? 'fillEllipse' : 'drawEllipse'
            | @!{layer.uid};!{pad}gfx->!{func}(!{layer.x}, !{layer.y}, !{layer.rx}, !{layer.ry}, !{layer.color});
        when 'triangle'
            - var func = layer.fill ? 'fillTriangle' : 'drawTriangle'
            | @!{layer.uid};!{pad}gfx->!{func}(!{layer.x1}, !{layer.y1}, !{layer.x2}, !{layer.y2}, !{layer.x3}, !{layer.y3}, !{layer.color});
        when 'string'
            if stringLayersNumber === 0
                - textColor = layer.color
                | !{pad}gfx->setTextColor(!{layer.color});
                |
                - stringLayersNumber++
            else if layer.color != textColor
                - textColor = layer.color
                | !{pad}gfx->setTextColor(!{layer.color});
                |
            if layer.scaleFactor != textSize
                - textSize = layer.scaleFactor
                | !{pad}gfx->setTextSize(!{layer.scaleFactor});
                |
            if layer.wrap != textWrap
                - textWrap = layer.wrap
                | !{pad}gfx->setTextWrap(false);
                |
            if layer.font != font 
                - font = layer.font
                if font == 'adafruit'
                    | !{pad}gfx->setFont();
                    |
                else
                    | !{pad}gfx->setFont(&!{layer.font});
                    |
            | !{pad}gfx->setCursor(!{layer.x}, !{layer.y});
            |
            if layer.isTextVariable
                | @!{layer.uid};!{pad}gfx->print(!{layer.text});
            else
                | @!{layer.uid};!{pad}gfx->println("!{layer.text}");
        when 'paint'
        when 'icon'
            if layer.colorMode === 'rgb'
                | @!{layer.uid};!{pad}gfx->draw16bitRGBBitmap(!{layer.x}, !{layer.y}, !{layer.imageName}, !{layer.w}, !{layer.h});
            else
                | @!{layer.uid};!{pad}gfx->drawBitmap(!{layer.x}, !{layer.y}, !{layer.imageName}, !{layer.w}, !{layer.h}, !{layer.color});
        when 'polygon'
            | @!{layer.uid};!{pad}!{layer.functionName}();
        default 
            |
            | // Unknown layer type !{layer.type}
            |
    |
    |
    |
|
if settings.wrap
    | }
    |
